export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST"
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS"
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE"
export const GET_NEXT_PAGE_PRODUCTS_REQUEST = "GET_NEXT_PAGE_PRODUCTS_REQUEST"
